import { Component } from 'react'
import * as Sentry from '@sentry/react'
import { reportError } from '../lib/errorReport'

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, info) {
    // Sentry con contexto React
    Sentry.withScope((scope) => {
      scope.setExtra('componentStack', info?.componentStack)
      Sentry.captureException(error)
    })
    // Nuestro logger casero (admin dashboard)
    reportError({
      severity: 'critical',
      message: error?.message || 'React component error',
      stack: error?.stack,
      source: 'frontend-react',
      extra: { componentStack: info?.componentStack },
    })
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null })
    window.location.reload()
  }

  render() {
    if (!this.state.hasError) return this.props.children
    return (
      <div className="min-h-screen bg-ink flex items-center justify-center p-6">
        <div className="max-w-md w-full bg-surface border border-line rounded-2xl p-6 text-center">
          <div className="w-12 h-12 rounded-full bg-error/15 border border-error/30 flex items-center justify-center mx-auto mb-4">
            <span className="text-error text-2xl">⚠</span>
          </div>
          <h2 className="font-display text-xl text-white mb-2">Algo ha fallado</h2>
          <p className="text-muted text-sm mb-5 leading-relaxed">
            Hemos recibido el error automáticamente. Recarga la página para continuar.
          </p>
          <button onClick={this.handleReload} className="btn-primary-aurora">
            Recargar
          </button>
        </div>
      </div>
    )
  }
}
